<template>
    <Card class="layout-card" style="height: 100%;">
        <div style="display:flex;justify-content: space-between;margin-bottom: 10px;flex-shrink: 0;">
            <div class="search-form">
                <Input :maxlength="100" v-model="searchForm.permissionName" placeholder="请输入权限名称" />
                <Input :maxlength="100" v-model="searchForm.permissionPath" placeholder="请输入权限路径" />
                <Button type="primary" v-if="buttonMenu['/permission/view']" @click="getData()">查询</Button>
                <Button @click="handleReset()">重置</Button>
            </div>
            <div><Button type="primary" v-if="buttonMenu['/permission/add']" @click="handleOpenEditModal()">添加</Button></div>
        </div>
        <div style="height: 100%;overflow:auto">
        <Table :data="tableData" :columns="columns">
            <template #action="{row}">
                <div>
                    <a style="margin-left: 10px;" v-if="buttonMenu['/permission/edit']" @click="handleOpenEditModal(row)">编辑</a>
                    <Poptip confirm title="确定要删除吗？" v-if="buttonMenu['/permission/delete']" transfer @on-ok="handleDel(row)"><a style="margin-left: 10px;color: red">删除</a></Poptip>

                </div>
            </template>
            <Pages slot="footer" :page="page" :func="getData"></Pages>
        </Table>
        </div>

        <Modal v-model="editVisible" :title="(form.id?'编辑':'新增')+'权限'">
            <Form @submit.native.prevent :label-width="100" :model="form" ref="formRef" v-if="editVisible">
                <FormItem label="权限名称：" prop="permissionName" :rules="[{required:true,message:'请输入权限名称'}]">
                    <Input :maxlength="100" v-model="form.permissionName" />
                </FormItem>
                <FormItem label="权限地址：" prop="permissionPath" :rules="[{required:true,message:'请输入权限地址'}]">
                    <Input :maxlength="100" v-model="form.permissionPath" />
                </FormItem>
            </Form>
            <template #footer>
                <Button @click="editVisible=false">取消</Button>
                <Button type="primary" :loading="submitLoading" @click="handleSubmit()">提交</Button>
            </template>
        </Modal>
    </Card>
</template>

<script>
import Pages from '@/components/pages'
import { getPermissionList, addPermission, delPermission, editPermission, getPermissionInfo } from '@/api/permission'
export default {
  components: {
    Pages
  },
  data() {
    return {
      editVisible:false,
      form:{},
      searchForm:{},
      submitLoading:false,
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      columns: [
        // {
        //   title: 'id',
        //   key: 'id'
        // },
        {
          title: '权限名称',
          key: 'permissionName'
        },
        {
          title: '权限路径',
          key: 'permissionPath'
        },
        {
          title: '创建人',
          key: 'createUserName'
        },
        {
          title: '创建时间',
          key: 'createTimeFmt'
        },
        {
          title: '修改人',
          key: 'updateUserName'
        },
        {
          title: '修改时间',
          key: 'updateTimeFmt'
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action'
        }
      ]
    }
  },
  computed:{
    buttonMenu() {
      const li = this.$store.getters.getMenuRules('system/permission')
      const obj = {}
      li.forEach(i => {
        obj[i.menuPath] = true
      })
      return obj
    }
  },
  methods:{
    getData(page) {
      if (page) this.page.current = page
      else this.page.current = 1
      getPermissionList({
        ...this.page,
        ...this.searchForm
      }).then(({ data }) => {
        console.log(data)

        this.tableData = data.records
        this.page.current = data.current
        this.page.total = data.total
      })
    },
    async handleOpenEditModal(row) {
      if (row) {
        const r = await getPermissionInfo(row.id)
        this.form = r.data
      } else {
        this.form = {}
      }
      this.editVisible = true
    },
    handleSubmit() {
      this.$refs.formRef.validate(r => {
        if (r) {
          const func = this.form.id ? editPermission : addPermission
          this.submitLoading = true
          func({
            ...this.form
          }).then(r => {
            this.$Message.success('操作成功')
            this.getData()
            this.submitLoading = false
            this.editVisible = false
          }).catch(() => {
            this.submitLoading = false
          })
        }
      })
    },
    handleDel(row) {
      delPermission(row.id).then(r => {
        this.$Message.success('操作成功')
        this.getData()
      })
    },
    handleReset() {
      this.searchForm = {}
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped lang="less">
.search-form{
    display:flex;
    &>*{
        margin: 0 5px;
    }
}
.layout-card{
  /deep/ .ivu-card-body{
    height: 100%;display:flex;flex-direction: column;
  }
}
</style>
